var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparxBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 14,
    viewBox: "0 0 67 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.823L0.69385 11.0649C2.26697 12.4453 3.71721 13.0872 5.82157 13.0872C7.92593 13.0872 9.43797 11.9399 9.43797 10.3838V10.3453C9.43797 8.9054 8.64111 8.0703 5.3926 7.448C1.96162 6.7872 0.571709 5.6784 0.571709 3.6169V3.5784C0.571709 1.5547 2.51272 0 5.16966 0C7.25341 0 8.62198 0.5439 10.0737 1.6527L9.39971 2.4493C8.05175 1.3405 6.70231 0.9135 5.12919 0.9135C3.02483 0.9135 1.63492 2.0608 1.63492 3.4811V3.5196C1.63492 4.9595 2.41118 5.8345 5.80317 6.4946C9.11202 7.1358 10.5019 8.2635 10.5019 10.2473V10.2858C10.5019 12.4838 8.52044 14 5.7627 14C3.47513 14 1.71733 13.2804 0.00147158 11.823H0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7512 7.82355V1.15325H18.7966C21.3711 1.15325 23.1274 2.28095 23.1274 4.43905V4.47755C23.1274 6.49985 21.3292 7.82215 18.6737 7.82215H16.3133V8.75455H18.6134C21.5962 8.75455 24.1914 7.27615 24.1914 4.41805V4.37955C24.1914 1.75455 22.0252 0.21875 18.879 0.21875H13.6895V13.8316H14.7519V8.75595",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2417 7.27825V1.15325H46.1237C48.7188 1.15325 50.2294 2.30055 50.2294 4.12825V4.16675C50.2294 6.13095 48.451 7.27825 46.0611 7.27825H42.8111V8.19175H45.9184L50.4744 13.8302H51.8223L47.103 8.01535C49.5134 7.70455 51.2911 6.40115 51.2911 4.12685V4.08835C51.2911 3.11605 50.8827 2.20255 50.2088 1.56065C49.3501 0.74305 47.9418 0.21875 46.184 0.21875H40.1777V13.8316H41.2402V8.19315",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7784 6.88765L54.3049 0.21875H55.5719L60.4539 6.22685L65.316 0.21875H66.5631L61.0675 6.88905L66.7684 13.8316H65.5014L60.4142 7.55125L55.3468 13.8316H54.0996L59.7784 6.88905V6.88765Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 2.2204L36.0978 12.8499H25.0882L30.6 2.2204ZM30.6014 0L23.4297 13.8313H37.7555L30.6014 0Z",
    fill: "url(#paint0_linear_22568_57202)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22568_57202",
    x1: 24.4414,
    y1: 14.7294,
    x2: 34.7105,
    y2: 5.62426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#652092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F54DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FF83B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparxBlack);
export default __webpack_public_path__ + "static/media/sparx-black.32fbb01766db3623a0557ff0251bc8bb.svg";
export { ForwardRef as ReactComponent };